import { createSlice } from '@reduxjs/toolkit';

import { setValues, setLoading } from './UI';
import { loginUser, logOutUser } from '../../services/hooks/authentication/useAuthentication';

const initialState = {
  isLogged: false,
  email: null,
  userId: null,
  profile: { roles: [] },
  businesses: {},
  businessId: null,
  isInternational: false,
  balance: { value: 0 }
};

export const userSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setUserValues: (state, action) => {
      Object.keys(action.payload).forEach(key => {
        state[key] = action.payload[key];
      });
    },
    setUserValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setBusiness: (state, action) => {
      state.businesses[action.payload.businessId] = action.payload.businessData;
    },
    setBusinessValue: (state, action)  => {
      state.businesses[action.payload.businessId][action.payload.key] = action.payload.value;
    },
    logOut: () => initialState
  }
});

export const loginUserAction = (email, password) => {
  return async dispatch => {
    dispatch(setLoading(true));
    const { username: userId } = await loginUser(email, password);
    dispatch(setUserValues({ userId }));
    dispatch(setLoading(false));
  };
};

export const logOutUserAction = () => {
  return async dispatch => {
    dispatch(setValues({ showSidebar: false }));
    dispatch(setLoading(true));
    await logOutUser();
    dispatch(logOut());
    dispatch(setLoading(false));
  };
};

export const { setUserValues, setUserValue, setBusiness, setBusinessValue, logOut } = userSlice.actions;
export default userSlice.reducer;
